/**
 * Where a lead came from.
 *
 * Captured once, when the app boots, and kept in memory only — no cookie and
 * no storage, so it needs no consent. Because the site is a single-page app
 * the values survive every in-site navigation and are still there when a
 * form is finally sent.
 *
 * Every lead form adds `leadAttribution()` to what it posts, so each
 * Formspree email says which channel produced it (Clutch, an outreach email
 * with ?utm_source=…, Google, a directory) and which page the visitor
 * landed on.
 */
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']

const capture = () => {
  if (typeof window === 'undefined') return {}
  const first = {}
  try {
    const params = new URLSearchParams(window.location.search)
    UTM_KEYS.forEach((key) => {
      const value = params.get(key)
      if (value) first[key] = value.slice(0, 120)
    })
    const referrer = document.referrer || ''
    // A referrer on our own origin is a reload, not a channel.
    first.referrer = referrer && !referrer.startsWith(window.location.origin) ? referrer.slice(0, 200) : 'direct'
    first.landing_page = window.location.pathname
  } catch (e) {
    // attribution must never break the page
  }
  return first
}

const firstTouch = capture()

// Fields to merge into a JSON lead payload.
export const leadAttribution = () => ({
  ...firstTouch,
  submitted_from: typeof window !== 'undefined' ? window.location.pathname : '',
})

export default leadAttribution
